import type {AnalyticsEvent} from "@khanacademy/event-schemas";
import type {PartialLearningTimeInfo} from "@khan/analytics-learning-time";

import type {ConversionName} from "../types.ts";

import {markConversion} from "./mark-conversion.ts";

export function publishAnalyticsEvent(
    event: AnalyticsEvent,
    learningTimeInfo: PartialLearningTimeInfo,
    legacyConversionName?: ConversionName,
): Promise<Response | void> {
    return markConversion(
        {
            id: legacyConversionName || "cedar_event",
            event,
        },
        learningTimeInfo,
    );
}
